import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { getProfileFeed } from '~~/src/api/feed'
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import { type GetArg } from '~~/src/types/utils'

export const useProfileFeed = (type: ElementalTypeEnum, ...args: GetArg<typeof getProfileFeed>) => {
  return useQuery({
    queryKey: (['profile-list-elementals', type, args] as const),
    queryFn: async ({ queryKey }) => {
      return getProfileFeed(...queryKey[2])
    },
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  })
}
